import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "spin"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["src"]
const _hoisted_5 = { slot: "content" }
const _hoisted_6 = { slot: "content" }
const _hoisted_7 = { style: {"color":"#888888"} }
const _hoisted_8 = { slot: "content" }
const _hoisted_9 = { style: {"color":"#888888"} }
const _hoisted_10 = { slot: "content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_home_action_item = _resolveComponent("home-action-item")!
  const _component_ion_accordion = _resolveComponent("ion-accordion")!
  const _component_ion_accordion_group = _resolveComponent("ion-accordion-group")!

  return ($setup.loadingData)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_ion_spinner)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        ($setup.clientHomeSlideImgUrl)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("img", {
                style: {"width":"100%","cursor":"pointer"},
                src: $setup.clientHomeSlideImgUrl,
                onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.openImageModal($setup.clientHomeSlideImgUrl)))
              }, null, 8, _hoisted_4)
            ]))
          : _createCommentVNode("", true),
        ($setup.userRelatedClient.includeAchieveJUPASData)
          ? (_openBlock(), _createBlock(_component_ion_card, {
              key: 1,
              class: "outer-card"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_item, {
                  lines: "full",
                  color: "fdmtred"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, null, {
                      default: _withCtx(() => _cache[2] || (_cache[2] = [
                        _createElementVNode("b", null, "AchieveJUPAS", -1)
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        ($setup.userRelatedClient.jobEXName)
          ? (_openBlock(), _createBlock(_component_ion_card, {
              key: 2,
              class: "outer-card"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_accordion_group, { value: "undergraduate" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_accordion, {
                      style: {"--min-height":"24px"},
                      value: "undergraduate"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_item, {
                          lines: "full",
                          slot: "header",
                          color: "fdmtred"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, null, {
                              default: _withCtx(() => [
                                _createElementVNode("b", null, _toDisplayString($setup.userRelatedClient.department) + "-specific career training", 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_card, { slot: "content" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_accordion_group, {
                              multiple: true,
                              value: ['coming']
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_accordion, {
                                  value: "coming",
                                  key: "coming"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_item, {
                                      slot: "header",
                                      color: "light"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                          default: _withCtx(() => _cache[3] || (_cache[3] = [
                                            _createElementVNode("p", { style: {"color":"#888888"} }, [
                                              _createElementVNode("b", null, "Coming")
                                            ], -1)
                                          ])),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createElementVNode("div", _hoisted_5, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.groupedUniSessions()['future'], (session) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: session.id
                                        }, [
                                          _createVNode(_component_home_action_item, {
                                            title: `${session.displayGroupName} [${session.date} ${session.startTime}] - ${session.status == 'TBC' ? 'Confirm' : session.status}`,
                                            hideIcon: true,
                                            onClick: ($event: any) => ($setup.openUniEventDetails(session.id)),
                                            textColor: session.status == 'Confirmed' ? 'success' : 'danger'
                                          }, null, 8, ["title", "onClick", "textColor"])
                                        ]))
                                      }), 128)),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.clientUniServices, (service) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: service.id
                                        }, [
                                          _createVNode(_component_home_action_item, {
                                            title: `${service.name} - Define date`,
                                            hideIcon: true,
                                            onClick: ($event: any) => ($setup.openServiceModal(service.id)),
                                            textColor: 'danger'
                                          }, null, 8, ["title", "onClick"])
                                        ]))
                                      }), 128))
                                    ])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ion_accordion, {
                                  value: "past",
                                  key: "past"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_item, {
                                      slot: "header",
                                      color: "light"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                          default: _withCtx(() => _cache[4] || (_cache[4] = [
                                            _createElementVNode("p", { style: {"color":"#888888"} }, [
                                              _createElementVNode("b", null, "Past")
                                            ], -1)
                                          ])),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createElementVNode("div", _hoisted_6, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.groupedUniSessions()['past'], (session) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: session.id
                                        }, [
                                          _createVNode(_component_home_action_item, {
                                            title: `${session.displayGroupName} [${session.date} ${session.startTime}]`,
                                            hideIcon: true,
                                            onClick: ($event: any) => ($setup.openSessionUniStudentListModal(session.id))
                                          }, null, 8, ["title", "onClick"])
                                        ]))
                                      }), 128))
                                    ])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        ($setup.userRelatedClient.id == 'caeb5730e')
          ? (_openBlock(), _createBlock(_component_ion_card, {
              key: 3,
              class: "outer-card"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_item, {
                  lines: "full",
                  color: "fdmtred"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, null, {
                      default: _withCtx(() => _cache[5] || (_cache[5] = [
                        _createElementVNode("b", null, "GIAWork", -1)
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        ($setup.userRelatedClient.workServiceId)
          ? (_openBlock(), _createBlock(_component_ion_card, {
              key: 4,
              class: "outer-card"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_accordion_group, { value: "F5" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_accordion, {
                      style: {"--min-height":"24px"},
                      value: "F5"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_item, {
                          lines: "full",
                          slot: "header",
                          color: "fdmtred"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, null, {
                              default: _withCtx(() => [
                                _createElementVNode("b", null, "Secondary School Students" + _toDisplayString($setup.userRelatedClient.workName ? `: ${$setup.userRelatedClient.workName}` : ""), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_card, { slot: "content" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_item, {
                              lines: "full",
                              color: "light",
                              onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.openSLPModal())),
                              button: "",
                              detail: ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                  default: _withCtx(() => _cache[6] || (_cache[6] = [
                                    _createElementVNode("p", { style: {"color":"#888888"} }, [
                                      _createElementVNode("b", null, "SLP tool for students")
                                    ], -1)
                                  ])),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_accordion_group, {
                              multiple: true,
                              value: ['coming']
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_accordion, {
                                  value: "coming",
                                  key: "coming"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_item, {
                                      slot: "header",
                                      color: "light"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("p", _hoisted_7, [
                                              _createElementVNode("b", null, "Coming " + _toDisplayString($setup.userRelatedClient.workName ? $setup.userRelatedClient.workName : "") + " schedule", 1)
                                            ])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createElementVNode("div", _hoisted_8, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.groupedWorkSessions()['future'], (session) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: session.id
                                        }, [
                                          _createVNode(_component_home_action_item, {
                                            title: `${session.displayGroupName} [${session.date} ${session.startTime}] - ${session.status == 'TBC' ? 'Confirm' : session.status}`,
                                            hideIcon: true,
                                            onClick: ($event: any) => ($setup.openUniEventDetails(session.id)),
                                            textColor: session.status == 'Confirmed' ? 'success' : 'danger'
                                          }, null, 8, ["title", "onClick", "textColor"])
                                        ]))
                                      }), 128)),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.clientServices, (service) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: service.id
                                        }, [
                                          (service.nature == 'Workshop')
                                            ? (_openBlock(), _createBlock(_component_home_action_item, {
                                                key: 0,
                                                title: `Workshop at university campus - Define date`,
                                                hideIcon: true,
                                                onClick: ($event: any) => ($setup.openServiceModal(service.id)),
                                                textColor: 'danger'
                                              }, null, 8, ["onClick"]))
                                            : _createCommentVNode("", true)
                                        ]))
                                      }), 128))
                                    ])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ion_accordion, {
                                  value: "past",
                                  key: "past"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_item, {
                                      slot: "header",
                                      color: "light"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("p", _hoisted_9, [
                                              _createElementVNode("b", null, "Past " + _toDisplayString($setup.userRelatedClient.workName ? $setup.userRelatedClient.workName : "") + " participation", 1)
                                            ])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createElementVNode("div", _hoisted_10, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.groupedWorkSessions()['past'], (session) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: session.id
                                        }, [
                                          _createVNode(_component_home_action_item, {
                                            title: `${session.displayGroupName} [${session.date} ${session.startTime}]`,
                                            hideIcon: true,
                                            onClick: ($event: any) => ($setup.openSessionStudentListModal(session.id))
                                          }, null, 8, ["title", "onClick"])
                                        ]))
                                      }), 128))
                                    ])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_ion_card, { class: "outer-card" }, {
          default: _withCtx(() => [
            ($setup.userRelatedClient.longReportLink)
              ? (_openBlock(), _createBlock(_component_ion_item, {
                  key: 0,
                  lines: "full",
                  href: $setup.userRelatedClient.longReportLink,
                  target: "_blank",
                  button: "",
                  detail: "",
                  color: "light"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                      default: _withCtx(() => _cache[7] || (_cache[7] = [
                        _createElementVNode("b", null, "Report", -1),
                        _createTextVNode(" (your Google account needed for secured sharing)")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["href"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]))
}